import React, { Component } from "react";
import "./ExportButton.css";

class ExportButton extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showExportOptions: false,
            exportSelectedOption: ""
        };

        this.dropdownRef = React.createRef();

        this.exportOptions = [
            // { label: "EXCEL", value: "EXCEL" },
            { label: "CSV", value: "CSV" }
        ];

        this.handleExportOptionSelect = this.handleExportOptionSelect.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.getButtonText = this.getButtonText.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {

        if (
            this.dropdownRef &&
            Object.prototype.hasOwnProperty.call(this.dropdownRef, "current") &&
            this.dropdownRef.current &&
            !this.dropdownRef.current.contains(event.target)
        ) {
            this.setState({ showExportOptions: false });
        }
    }

    toggleDropdown() {

        let loading = false;

        if (
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, "loading")
        ) {
            loading = this.props.loading;
        }

        if (loading) return;

        // if only 1 option -> directly call export
        if (this.exportOptions.length === 1) {

            const value = this.exportOptions[0].value;

            this.setState({
                exportSelectedOption: value,
                showExportOptions: false
            });

            if (
                this.props &&
                Object.prototype.hasOwnProperty.call(this.props, "onExport") &&
                this.props.onExport
            ) {
                this.props.onExport(value);
            }

            return;
        }

        // if more than 1 option -> show dropdown
        this.setState({
            showExportOptions: !this.state.showExportOptions
        });
    }

    handleExportOptionSelect(value) {

        this.setState({
            exportSelectedOption: value,
            showExportOptions: false
        });

        if (
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, "onExport") &&
            this.props.onExport
        ) {
            this.props.onExport(value);
        }
    }

  getButtonText() {

    let loading = false;

    if (
        this.props &&
        Object.prototype.hasOwnProperty.call(this.props, "loading")
    ) {
        loading = this.props.loading;
    }

    const label = this.props.label || "Export"; // 👈 fallback

    if (loading) {
        return label + "ing...";
    }

    // single option -> simpler label
    if (this.exportOptions.length === 1) {
        return label + " " + this.exportOptions[0].label;
    }

    if (this.state.exportSelectedOption !== "") {
        return label + ": " + this.state.exportSelectedOption;
    }

    return label + ": Select";
}

    render() {

        let loading = false;

        if (
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, "loading")
        ) {
            loading = this.props.loading;
        }

        let buttonClass = "export-btn";

        if (loading) {
            buttonClass = "export-btn loading";
        }

        return (

            <div className="export-container">

                <div
                    className="export-wrapper"
                    ref={this.dropdownRef}
                >

                  <button
    onClick={loading ? undefined : this.toggleDropdown}
    disabled={loading}
    className="export-btn"
    style={{
        opacity: loading ? 0.6 : 1,
        cursor: loading ? "not-allowed" : "pointer",
        pointerEvents: loading ? "none" : "auto",
        position: "relative"
    }}
>

    <span className="icon">📄</span>

    {this.getButtonText()}

    {this.exportOptions.length > 1 &&
        <span className="arrow">▼</span>
    }

    {loading &&
        <span
            style={{
                marginLeft: "8px",
                border: "2px solid #ccc",
                borderTop: "2px solid #333",
                borderRadius: "50%",
                width: "14px",
                height: "14px",
                display: "inline-block",
                animation: "spin 0.7s linear infinite"
            }}
        />
    }

</button>


                    {this.exportOptions.length > 1 &&
                        this.state.showExportOptions &&
                        <div className="export-dropdown">

                            {this.exportOptions.map((option, index) => {

                                let optionClass = "option";

                                if (this.state.exportSelectedOption === option.value) {
                                    optionClass = "option selected";
                                }

                                return (

                                    <div
                                        key={index}
                                        className={optionClass}
                                        onClick={() => this.handleExportOptionSelect(option.value)}
                                    >

                                        {option.label}

                                        {this.state.exportSelectedOption === option.value &&
                                            <span className="check">✔</span>
                                        }

                                    </div>

                                );
                            })}

                        </div>
                    }

                </div>

            </div>

        );
    }
}

export default ExportButton;